import React from 'react';
import { HomeIcon, TrendingUpIcon, HandshakeIcon, FileTextIcon, BadgeCheckIcon, BuildingIcon } from 'lucide-react';
const services = [{
  icon: HomeIcon,
  title: 'Property Selection',
  description: 'Curated investment-grade properties matched to your goals and budget.'
}, {
  icon: TrendingUpIcon,
  title: 'ROI Analysis',
  description: 'Data-driven projections on capital appreciation and rental yields.'
}, {
  icon: HandshakeIcon,
  title: 'Developer Negotiations',
  description: 'Leveraging our partnerships to secure the best terms and pricing.'
}, {
  icon: FileTextIcon,
  title: 'Legal Documentation',
  description: 'End-to-end support with contracts, compliance, and ownership transfer.'
}, {
  icon: BadgeCheckIcon,
  title: 'Golden Visa Eligibility',
  description: 'Guidance on qualifying for UAE residency through property investment.'
}, {
  icon: BuildingIcon,
  title: 'Post-Purchase Rental Management',
  description: 'Hands-off income generation with professional property management.'
}];
export const WhyTrustSection = () => {
  return <section className="bg-white py-16 md:py-24 relative overflow-hidden" data-id="element-552">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#1a2e1c] opacity-[0.02] rounded-full blur-3xl pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-553"></div>

      <div className="container mx-auto px-4 md:px-8" data-id="element-554">
        <div className="max-w-5xl mx-auto" data-id="element-555">
          {/* Header */}
          <div className="text-center mb-14 md:mb-16" data-id="element-556">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-[#1a1a1a] leading-tight mb-6" data-id="element-557">
              Why Investors Trust{' '}
              <span className="text-[#d8a34d]" data-id="element-558">Ikigai Real Estate</span>
            </h2>
            <p className="text-gray-500 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-559">
              Ikigai Real Estate specializes in helping global investors enter
              Dubai's rapidly growing property market with curated investment
              opportunities and professional guidance.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10 mb-14" data-id="element-560">
            {services.map((service, index) => {
            const Icon = service.icon;
            return <div key={index} className="flex gap-4" data-id="element-561">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#1a2e1c]/5 flex items-center justify-center" data-id="element-562">
                    <Icon className="w-5 h-5 text-[#d8a34d]" data-id="element-563" />
                  </div>
                  <div data-id="element-564">
                    <h3 className="font-display font-bold text-[#1a1a1a] text-base md:text-lg mb-1.5" data-id="element-565">
                      {service.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed" data-id="element-566">
                      {service.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

          {/* Closing statement */}
          <div className="text-center" data-id="element-567">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1a2e1c]/5 border border-[#1a2e1c]/10" data-id="element-568">
              <span className="text-[#1a1a1a] text-sm font-medium" data-id="element-569">
                We focus on investment-grade properties with strong capital
                appreciation potential
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};